<template>
  <b-row>
    <b-col>
      <campaign-search
        :pagination="pagination"
        @change="onSearchResult"
        @click="onSearchClick"
      />

      <router-link :to="{name: 'add-campaign'}">
        <b-button variant="info">Add Campaign</b-button>
      </router-link>
    </b-col>
    <b-col cols="12">
      <transition name="slide">
        <b-card>
          <div slot="header">
            <strong>Campaigns</strong>
          </div>
          <pagination-table
            :items="campaigns"
            :fields="[
              {key: 'title'},
              {key: 'status'},
              {key: 'sendAt'},
              {key: 'actions'},
            ]"
            :pagination="pagination"
            :is-loading="isLoading"
            item-url="newsletter/campaigns/{id}"
          ></pagination-table>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import PaginationTable from "@/components/base/PaginationTable";
import {RepositoryFactory} from "@/services/repositories/RepositoryFactory";
import {PaginationMeta} from "@/models/PaginationMeta";
import CampaignSearch from "@/components/newsletter/Campaign/CampaignSearch";

export default {
  name: "Campaigns",
  components: {
    CampaignSearch,
    PaginationTable,
  },
  data() {
    return {
      campaigns: [],
      isLoading: false,
      pagination: new PaginationMeta(),
    }
  },
  mounted() {
    this.isLoading = true;
    RepositoryFactory
      .get('newsletterCampaign')
      .get()
      .then(
        response => {
          this.campaigns = response.data.data;
          this.pagination = response.data.meta;
          this.isLoading = false;
        }
      )
  },
  methods: {
    onSearchResult(response) {
        this.campaigns = response.data,
        this.pagination = response.meta,
        this.isLoading = false
    },
    onSearchClick(params) {
      this.isLoading = true
    }
  }
}
</script>

<style scoped>

</style>
